import z from 'zod'

export const frenchNumberSchema = z.preprocess(
  (val) => (typeof val === 'string' ? val.replace(',', '.') : val),
  z.coerce.number('La valeur doit être un nombre'),
)

export const requiredFrenchNumberSchema = z
  .any()
  .refine(
    (value) => value !== null && value !== undefined && String(value).trim() !== '',
    'Ce champ est obligatoire',
  )
  .pipe(frenchNumberSchema)
